<div
  class="container-fluid tw-relative tw-bg-white tw-pb-12 tw-overflow-hidden tw-min-h-[100dvh]"
>
  <!-- Fondo decorativo inferior derecho -->
  <div
    class="tw-absolute tw-inset-0 tw-bg-no-repeat tw-bg-left-bottom tw-bg-[url('/assets/images/logoOrange2.png')] tw-opacity-60 tw-blur-xs tw-z-0 tw-pointer-events-none "
    style="background-size: 280px"
  ></div>

  <!-- Contenido principal -->
  <div class="tw-relative tw-z-10">
    <!-- Encabezado -->
    <div class="tw-max-w-6xl tw-mx-auto tw-px-4">
      <h2
        class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight"
      >
        <span class="tw-text-[#F67011]">
          PROMOCIONES
          <span class="tw-text-black">DE INSTALACIÓN</span>
        </span>
      </h2>
     
    </div>

    <!-- Grid de tarjetas -->
    <div class="tw-max-w-3xl tw-mt-4 tw-mx-auto tw-px-4 tw-py-2 tw-z-10">
        <div
          class="tw-grid tw-gap-2 md:tw-gap-0 tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-2 tw-mt-4 tw-z-10"
        >
          <div
            class="tw-flex tw-flex-col tw-h-full  tw-rounded-xl md:tw-rounded-none md:tw-rounded-l-xl md:tw-overflow-hidden hover:-tw-translate-y-1.5 tw-transition-all tw-duration-500 tw-ease-in-out tw-border tw-border-gray-300"
          >
            <div class="tw-overflow-hidden tw-rounded-xl md:tw-rounded-none sm:tw-flex-auto md:tw-flex-1 ">
              <app-card-promotion
                [buttonText]="'Lo quiero'"
                [icono]="'bi bi-speedometer'"
                [text]="
                  ' Mano de obra básica gratis hasta 100 mts. Materiales Onu (módem router), cableado fibra óptica drop, patchcord caja de terminación, tensores para cable drop  entregados en calidad de comodato (préstamo), es decir son propiedad de la empresa y lo retiramos cuando desista del servicio. ¡Solo pagas por la velocidad que necesitas!
'
                "
                [title]="'MANO DE OBRA BÁSICA'"
                [subTitle]="'GRATIS'"
              ></app-card-promotion>
            </div>
          </div>
  
          
  
          <div
            class="tw-flex tw-flex-col tw-h-full tw-rounded-xl md:tw-rounded-none  md:tw-rounded-r-xl md:tw-overflow-hidden hover:-tw-translate-y-1.5 tw-transition-all tw-duration-500 tw-ease-in-out tw-border tw-border-gray-300"
          >
            <div class="tw-overflow-hidden tw-rounded-xl md:tw-rounded-none sm:tw-flex-auto md:tw-flex-1">
              <app-card-promotion
                [buttonText]="'Lo quiero'"
                [icono]="'bi bi-headset'"
                [text]="
                  'Te obsequiamos el primer MES GRATIS y la mano de obra por instalación hasta 100 metros, Materiales Onu (módem router), cableado fibra óptica drop, patchcord caja de terminación, tensores para cable drop  entregados en calidad de comodato (préstamo), es decir son propiedad de la empresa y lo retiramos cuando desista del servicio. únicamente cancelando el costo del plan de su preferencia.'
                "
                [title]="'MIGRA A'"
                [subTitle]="'NOSOTROS'"
              ></app-card-promotion>
            </div>
          </div>
        </div>
        
      </div>
  </div>
</div>
